import _pick from "lodash.pick";
import { Platform } from "react-native";
import { create as createZStore } from "zustand";
import {
  createJSONStorage,
  persist,
  subscribeWithSelector,
} from "zustand/middleware";

import * as SecureStorage from "./secure-storage";
import * as UnsecureStorage from "./unsecure-storage";

//
// State
//
export interface StoreState {
  isHydrating: boolean;
}

type StoreOptions = {
  persist?: string[];
};

export function createStore<T extends object>(
  name: string,
  initialState: T,
  options: StoreOptions = {}
) {
  // Values to persist
  const whiteList = options.persist ?? [];

  const store = createZStore<T & StoreState>()(
    persist(
      subscribeWithSelector((set) => ({ ...initialState, isHydrating: true })),
      {
        name,
        storage: createJSONStorage(
          () => (Platform.OS === "web" ? UnsecureStorage : SecureStorage) // TODO: Ugly
        ),
        onRehydrateStorage: () => init,
        partialize: (state) => _pick(state, whiteList),
      }
    )
  );

  function init() {
    store.setState((state) => ({ ...state, isHydrating: false }));
  }

  return store;
}
